"use strict";
/*
Copyright (C) 2009 - 2020 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultSavedPaymentMethodOwningUserType = void 0;
var DefaultSavedPaymentMethodOwningUserType;
(function (DefaultSavedPaymentMethodOwningUserType) {
    /**
     * Represents a Broadleaf-managed customer.
     */
    DefaultSavedPaymentMethodOwningUserType["BLC_CUSTOMER"] = "BLC_CUSTOMER";
    /**
     * Represents a Broadleaf-managed account.
     */
    DefaultSavedPaymentMethodOwningUserType["BLC_ACCOUNT"] = "BLC_ACCOUNT";
})(DefaultSavedPaymentMethodOwningUserType = exports.DefaultSavedPaymentMethodOwningUserType || (exports.DefaultSavedPaymentMethodOwningUserType = {}));
//# sourceMappingURL=saved-payment-method.js.map